import moment from 'moment'
import { EDDM_SIGNUP } from '../../shared/constants'
import { authorization } from '../../Module/Auth/Auth'
import { ROLE_CLIENT, ROLE_CLIENT_ADMIN } from '../../shared/constants'

export const getBAName = ({ firstName, lastName, isTeamLeader }) => {
  const lastNameValue = isNeedToHideEmployeeLastName()
    ? hideUserLastName(lastName)
    : lastName

  return `${isTeamLeader ? '⭐' : ''} ${firstName} ${lastNameValue}`
}

export const getBADateOfBirth = user => {
  return user.dateOfBirth ? moment(user.dateOfBirth).utc() : null
}

export const getSignupSource = source => {
  switch (source) {
    case 'qrBuilder':
      return 'qr_signup'
    case 'eddm':
      return 'eddm_signup'
    default:
      return 'ss_signup'
  }
}

export const getIsEddmUser = source => getSignupSource(source) === EDDM_SIGNUP

export const isNeedToHideEmployeeLastName = () => {
  const user = authorization.getUser()
  return user && [ROLE_CLIENT, ROLE_CLIENT_ADMIN].includes(user.role)
}

export const formatLastName = x =>
  isNeedToHideEmployeeLastName() ? hideUserLastName(x) : x

export const hideUserLastName = lastName =>
  lastName ? lastName[0].toUpperCase() : ''
